import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

function LegalShell({ title, product, children }) {
  return (
    <div className="min-h-screen noise-bg pt-24 pb-20" data-testid="legal-page">
      <div className="container-custom max-w-3xl">
        <Link to={`/products/${product}`} className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-cyan-400 transition-colors mb-8" data-testid="legal-back-link">
          <ArrowLeft size={16} /> Back to {product === 'sva-detox' ? 'Sva — Detox' : 'Product'}
        </Link>
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="legal-title">{title}</h1>
        <p className="text-sm text-slate-600 mb-10">Sva — Detox · BastionGuard Medical Technologies Pvt. Ltd.</p>
        <article className="prose-legal">{children}</article>
      </div>
    </div>
  );
}

export default LegalShell;
